/**
 * WishlistButton class.
 * @extends HTMLElement
 */
if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class WishlistButton extends HTMLElement {
      constructor() {
        super();

        this.productId = this.getAttribute('data-product-id');
        this.variantId = this.getAttribute('data-variant-id');
      }

      /**
       * Invoked each time the custom element is appended into a document-connected element.
       * Ensures the Swym integration is initialized once the API is ready.
       */
      connectedCallback() {
        window.SwymCallbacks ??= [];
        window.SwymCallbacks.push(this.initSwym.bind(this));
      }

      /**
       * Initializes the Swym interaction for this specific button.
       * Fetches the wishlist event data (event type 4) to see what the user has saved.
       */
      async initSwym() {
        if (typeof _swat !== 'undefined' || !window.SwymProducts || !window.SwymProducts.length) this.updateList(this.initWishlist.bind(this));
      }

      /**
       * Evaluates whether the current product/variant exists in the user's fetched wishlist.
       * If it is, updates the UI to favorited. If not, attaches the event listener to add it.
       */
      initWishlist() {
        this.updateIcon();

        this.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        });
      }

      /**
       * Constructs the product payload and sends it to the Swym API to add to the wishlist.
       * Triggers the UI update callback upon success.
       */
      toggle() {
        // Create a local object for this specific product card
        const productData = {
          empi: Number(this.productId),
          epi: Number(this.variantId),
          et: 4, // et 4 stands for wishlist event type
        };

        // Check if product is in wishlist
        const isInWishlist = window.SwymProducts.some((p) => String(p.empi) === String(this.productId) && String(p.epi) === String(this.variantId));

        // Perform add/remove action
        isInWishlist ? _swat.removeFromWishList(productData, () => this.updateList(this.updateIcon.bind(this))) : _swat.addToWishList(productData, () => this.updateList(this.updateIcon.bind(this)));
      }

      /**
       * Updates the product list
       * Triggers the callback, if provided
       * * @param {Function} callback - The callback function to run.
       */
      updateList(callback) {
        _swat.fetchWrtEventTypeET((products) => {
          window.SwymProducts = products;
          if (callback) callback();
        }, 4);
      }

      /**
       * Updates the icon.
       */
      updateIcon() {
        // Check against this button's specific IDs, not the global SwymPageData
        const isInWishlist = window.SwymProducts.some((p) => String(p.empi) === String(this.productId) && String(p.epi) === String(this.variantId));
        this.classList.toggle('swym-added', isInWishlist);
        this.classList.remove('hidden');
      }
    },
  );
}
